import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from "react-router-dom"
import Toggle from "react-toggle"
import { getDSPsPlatformFee, replacePanCardImage, updateDSP, updateDSPsPlatformFee } from '../../apis/adminAPIs/dsp'
import Popup from '../../ReusableFunctions/Popup'
import { getLocation } from '../../apis/locations'
import { getFormatedDate } from '../../ReusableFunctions/reusableFunctions'
import { GLOBAL_STYLES } from '../../appConstants'
import MainContentWrapper from '../../Components/MainContentWrapper'
import { useSelector } from 'react-redux'
import Loading from '../../ReusableFunctions/Loader'
import { PDRL_ADMIN_ROUTES } from '../../routes'
import Subscription from '../../ReusableFunctions/Subscription'
import { Button } from '../../Components/Helper'
import { getSubscriptionPlansAPI } from '../../apis/BhuMeetTeams/Oparations/subscriptions'

const ViewOperationDsp = ({ dsp, callback, hideBankDetails, isToggleDisabled,notshow }) => {
const {pathname}=useLocation();
    const [location, setLocation] = useState([])
    const [isEdit, setisEdit] = useState(false)
    const [platformFee, setPlatformFee] = useState("");
    const [openSubModal,setOpenSubModal] = useState(false)
    const [planType, setPlanType] = useState(null);
    const user = useSelector(state => state.user?.user)
    const fileInputRef = useRef(null);
    const [selectedFile, setSelectedFile] = useState(undefined)
     const [filters, setFilters] = useState({
            pageNumber: 1,
            pageSize: 15,
            searchQuery: '',
            type: "yearly"
        })
    const [planDetails,setPlanDetails] = useState()

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const validTypes = ['application/pdf', 'image/jpeg', 'image/png'];
            if (!validTypes.includes(file.type)) {
                Popup.alert("Error", "Please upload a valid file (PDF, JPG, PNG)", "ERROR");
                return;
            }
            
            // Validate file size (max 5MB)
            if (file.size > 10 * 1024 * 1024) {
                Popup.alert("Error", "File size should be less than 10MB", "ERROR");
                return;
            }
            
            setSelectedFile(file);
            handleReplaceIdentityImage(file)
        }
    };


    const handleReplaceIdentityImage = async (file) => {
      Loading.set(true);
        try {
            // Create form data
            const formData = new FormData();
            formData.append('identity', file);
            formData.append('dspOperator_id', dsp.dsp_id);
            formData.append('blob_container', dsp.dsp_blob_container);
            formData.append('type', "pan_card"); 
            let updatedDsp=await replacePanCardImage(formData);
            Popup.alert("Success", "identity replaced successfully", "SUCCESS",()=>{
                callback(updatedDsp,true,false);
            });
        } catch (err) {
            Popup.alert("Error", err.message || "Failed to replace document", "ERROR");
        } finally {
            Loading.set(false);
            setSelectedFile(null);
            if (fileInputRef.current) {
                fileInputRef.current.value = ''; // Reset file input
            }
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    console.log(notshow)
    const getLocationFunc = async () => {
        try {

            const location = await getLocation(dsp.operator_location_id);
            setLocation(location)
        } catch (err) {
            Popup.alert("ERROR", err, "ERROR")
        }
    }
    const updateDSPFunc = async (dsp) => {
        try {
            await updateDSP({ id: dsp.dsp_id, is_active: dsp.dsp_is_active })
            callback(dsp);
        } catch (err) {
            Popup.alert("Error", err, 'ERROR')
        }
    }

     const getSubscriptionPlanList = async (customFilters = filters) => {
        try {
             Loading.set(true);
            console.log("plan", customFilters)
            let planDetails = await getSubscriptionPlansAPI(customFilters);

            const mappedPlans = planDetails.map(plan => ({
                label: plan.name,
                value: plan.id,
                ...plan
            }));
        //    mappedPlans.forEach(p => console.log("Plan:", p.label, p.value));
            setPlanDetails(mappedPlans)
             Loading.set(false);
        } catch (err) {
             Loading.set(false);
            Popup.alert("ERROR", "Something went wrong while fetching subscription details")
            console.log("err", err);
        }
    }

    const handlePlanFilters = (planValue) => {
        console.log("plan value", planType);
        const updatedFilters = {
            ...filters,
            type: planValue || dsp.subscription_details?.type || "yearly",
        };
        setFilters(updatedFilters);
        getSubscriptionPlanList(updatedFilters);
    }

    useEffect(() => {
        if (planType) {
          const updatedFilters = { ...filters, type: planType };
          setFilters(updatedFilters);
          getSubscriptionPlanList(updatedFilters);
        }
    }, [planType]);      

    const getFee = async () => {
        try {
            if(user.bhumeet_role === 'Admin' && !notshow){
                const fee = await getDSPsPlatformFee(dsp.dsp_id);
                setPlatformFee(fee)
                dsp.dsp_platform_fee_on_online_percentage = fee
            }else{
                setPlatformFee(dsp.dsp_platform_fee_on_online_percentage)
            }
            
        } catch (err) {
            Popup.alert("ERROR", err, "ERROR")
        }
    }

    const updatePlatformFee = async () => {
        try {
            if (platformFee == '' && isEdit) return
            else if (platformFee != '' && isEdit) {
                if(dsp.dsp_platform_fee_on_online_percentage == platformFee){
                    setisEdit(false)
                    // Popup.alert("WARNING","Cannot Update Same Platform fee.","ERROR")
                    return
                }
                
                Popup.alert("Platform Fee",<p>Are you sure,You want change Platform Fee for DSP : <b>{dsp.dsp_name}</b> from <b>{dsp.dsp_platform_fee_on_online_percentage}</b> to <b>{platformFee}</b> .</p>,"WARNING",async()=>{
                    console.log("Clicked OK")
                    await updateDSPsPlatformFee(dsp.dsp_id, platformFee)
                    
                    getFee()
                    Popup.alert("SUCCESS","Successfully Updated Platform Fee","SUCCESS")
                    setisEdit(!isEdit)
                },null,"Yes",()=>{
                    console.log("Clicked Cancel")
                    setPlatformFee(dsp.dsp_platform_fee_on_online_percentage)
                    setisEdit(!isEdit)
                    return
                },"No")
                
            } else {
                setisEdit(!isEdit)
            }

        } catch (err) {
            Popup.alert("Error", err, 'ERROR')
        }
    }

    useEffect(() => {
        getFee()
        if (dsp.operator_location_id)
            getLocationFunc()
    }, [])
    return (
        <MainContentWrapper containerStyle={{
            height: "750px",
        }} >
            <div style={{ height: "100%", background: "rgb(244, 244, 244)", padding: "0px 0px 20px 0px" }}>
                <div style={{ display: "flex", justifyContent: "space-between", gap: "20px", background: "#D9D9D9D9", padding: "20px" }}>
                <input
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                accept=".pdf,.jpg,.jpeg,.png"
                style={{ display: 'none' }}
            />
                    <div style={{ display: "flex", width: "100%", justifyContent: "space-between", alignItems: "center", gap: "10px" }}>
                        <div style={{ fontSize: "14px" }}>DSP Details</div>
                        {!isToggleDisabled && <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                            <label style={{ display: "flex", alignItems: "center", justifyContent: "center" }} onClick={(e) => e.stopPropagation()}>
                                <Toggle
                                    className='admin'
                                    checked={dsp.dsp_is_active}
                                    icons={false}
                                    onChange={(e) => {
                                        const provider = { ...dsp, dsp_is_active: e.target.checked }
                                        if (e.target.checked)
                                            updateDSPFunc(provider)
                                        else
                                            Popup.alert("Warning", "Are u sure u want to deactivate this account? Related teams accounts and app will be shut down!", "WARNING", () => updateDSPFunc(provider))
                                    }}
                                />
                            </label>
                            <span style={{ color: dsp.dsp_is_active ? "green" : "red", fontSize: GLOBAL_STYLES.FONT_SIZE_SMALL }}>{dsp.dsp_is_active ? "DSP Active" : "DSP Inactive"}</span>
                        </div>}
                    </div>
                </div>
                <div style={{ overflowY: "auto", height: "calc(100% - 50px)", fontSize: GLOBAL_STYLES.FONT_SIZE_MEDIUM, padding: "20px" }}>
                    
                    <div style={{ fontWeight: 600, marginBottom: "10px" }}>Owner Details</div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>

                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }} >Id</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{dsp.operator_id || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Name</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{dsp.operator_name || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Address</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{dsp.operator_address || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Created On</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{getFormatedDate(dsp.dsp_date_created) || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Phone number</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{dsp.operator_phone || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Identity</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>
                                {(dsp.operator_aadhar_url || dsp.operator_pan_url) ? <a target='_blank' style={{ color: "blue" }} href={dsp.operator_aadhar_url || dsp.operator_pan_url || ""}>{'View'}</a> : "-"}
                            </div>
                            {pathname===PDRL_ADMIN_ROUTES.DSPDASHBOARD &&(
                            <div onClick={triggerFileInput} style={{marginLeft:"10px",color:"blue",cursor:"pointer"}}>
                                {((dsp.operator_aadhar_url || dsp.operator_pan_url)) ? 'Replace' : "Change"}
                            </div>
                            )}
                        </div>

                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Location</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{location.name || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>PDRL admin</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{ color: dsp.operator_is_pdrl_admin ? "green" : "red" }}>{dsp.operator_is_pdrl_admin ? "Yes" : "No" || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Admin</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{ color: dsp.operator_is_admin ? "green" : "red" }}>{dsp.operator_is_admin ? "Yes" : "No" || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Account Status</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{ color: dsp.operator_is_active ? "green" : "red" }}>{dsp.operator_is_active ? "Active" : "Inactive" || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Email</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{dsp.operator_email || "-"}</div>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ color: "gray" }}>Platform Fee</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            {isEdit ? (
                                <input
                                    type="float"
                                    value={platformFee}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Allow empty input or valid float numbers
                                        
                                        if (value === "" || (/^(\d+(\.\d{0,3})?)?$/.test(value) && parseFloat(value) < 100)) {
                                            setPlatformFee(value);
                                          }

                                    }
                                    }
                                    style={{ width: "30px", marginRight: "5px" }}
                                />
                            ) : (
                                <div>{platformFee + "%" || "-"}</div>
                            )}
                            {(user.bhumeet_role == 'Admin' && !notshow) && 
                                <>
                                <div
                                onClick={() => {
                                    updatePlatformFee()
                                }
                                }
                                style={{ marginLeft: "5px", color: "blue", cursor: (platformFee == '' && isEdit) ? "not-allowed" : "pointer" }}
                            >
                                <h6>{isEdit ? "Save" : "Edit"}</h6>
                            </div>
                            {(isEdit) &&

                                <div
                                    onClick={() => {
                                        setPlatformFee(dsp.dsp_platform_fee_on_online_percentage)
                                        setisEdit(!isEdit)
                                    }
                                    }
                                    style={{ marginLeft: "5px", color: "blue", cursor: "pointer" }}
                                >
                                    <h6>{"Cancel"}</h6>
                                </div>
                            }
                                </>
                            }
                            
                        </div>
                    </div>


                    <br />
                    <div style={{ fontWeight: 600, margin: "10px 0px" }}>Company details</div>
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>

                        <div style={{ display: "flex" }}>
                            <div >Registration Number</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{dsp.dsp_registration_number || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Dsp Id</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{dsp.dsp_id || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Name</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{dsp.dsp_name || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Logo</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{ display: "flex" }}>
                                {dsp.dsp_logo_url ? <a target='_blank' style={{ color: "blue" }} href={dsp.dsp_logo_url || ""}>View</a> : "-"}
                            </div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Verified</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{ color: dsp.dsp_is_verified ? "green" : "red" }}>{dsp.dsp_is_verified ? "Yes" : "No" || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Status</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{ color: dsp.dsp_is_active ? "green" : "red" }}>{dsp.dsp_is_active ? "Active" : "Inactive" || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Information</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{dsp.dsp_information || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Created on</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{getFormatedDate(dsp.dsp_date_created) || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Address</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{}}>{dsp.dsp_address || "-"}</div>
                        </div>
                        <div style={{ display: "flex" }}>
                            <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>PAN No.</div>
                            <div style={{ margin: "0px 10px" }}>:</div>
                            <div style={{ display: "flex", gap: "0.4rem" }}>
                                {dsp.operator_pan_number && (
                                    <div>{dsp.operator_pan_number}</div>
                                )}
                                {dsp?.operator_pan_url ? <a target='_blank' style={{ color: "blue" }} href={dsp?.operator_pan_url || ""}>{'View'}</a> : "-"}
                            </div>
                        </div>
                    </div>
                    <br />
                    {!hideBankDetails && (
                        <>
                            <div style={{ fontWeight: 600, margin: "10px 0px" }}>Bank details</div>
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>

                                <div style={{ display: "flex" }}>
                                    <div >Bank Name</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp.bank_name || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>IFSC Code</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp.ifsc_code || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Account No.</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp.account_no || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Account Holder Name</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp.account_holder_name || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Account Type</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp.account_type || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Branch Address</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp.branch_address || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Account Status</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{ color: dsp.acc_status ? "green" : "red" }}>{dsp.acc_status ? "Active" : "Inactive" || "-"}</div>
                                </div>
                            </div>
                        </>

                    )}
                    <>
                        <div className='flex w-[55%] justify-between items-center'>
                            <div style={{ fontWeight: 600, margin: "25px 0px" }}>Subscription Details</div>
                            <Button text={dsp?.subscription_details ? "Modify" : "Add"} onClick={() => {setOpenSubModal(true);
                             handlePlanFilters(dsp?.subscription_details?.type === "trial" ? "monthly" : dsp?.subscription_details?.type);
                            }} />
                        </div>
                        {dsp?.subscription_details ?
                            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "20px" }}>

                                <div style={{ display: "flex" }}>
                                    <div >Plan Name</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp?.subscription_details?.plan_name || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Description</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp?.subscription_details?.plan_description || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Subscription Number</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp?.subscription_details?.sub_number || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Plan Type</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp?.subscription_details?.type || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Leads Offer</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp?.subscription_details?.limits['leads']?.limits || "-"}</div>
                                </div>
                                <div style={{ display: "flex" }}>
                                    <div style={{ color: GLOBAL_STYLES.FONT_COLOR_SUB }}>Leads Usage</div>
                                    <div style={{ margin: "0px 10px" }}>:</div>
                                    <div style={{}}>{dsp?.subscription_details?.limits['leads']?.usage}</div>
                                </div>
                            </div>
                            : <div className='text-center min-h-[100px] items-center flex justify-center '>
                                No Active Subscription
                            </div>}

                    </>

                </div>
            </div>

             <Subscription
                        open={openSubModal}
                        onClose={() => setOpenSubModal(false)}
                        planDetails={planDetails}
                        dspDetails={dsp}
                        setOpenSubModal={setOpenSubModal}
                        setPlanType={setPlanType}
                        onSuccess={(updatedDsp) => {
                            setOpenSubModal(false);
                            callback(updatedDsp, false,true);
                        }}
                        onChange={planType => {
                            const updatedFilters = { ...filters, type: planType}
                            setFilters(updatedFilters);
                        }}
                    />
        </MainContentWrapper>
    )
}

export default ViewOperationDsp